import styled, { css, keyframes } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import progressBarBackgroundColor from 'common/ProgressBarBackgroundColor';
import { zIndex } from 'styles';
import {
  getRemBaseFontSize
} from 'common/parse-tokens';
import circularProgressIndicatorIndeterminateStyles, {
  circleAnimation,
  circleAnimationRtl,
} from 'components/CircularProgressIndicatorIndeterminate/styles';

const MIN_HEIGHT = 3;
const SINGLE_REM = getRemBaseFontSize();
const SINGLE_LINE_HEIGHT = (Tokens.TYPOGRAPHY.BODY.lineHeight * parseFloat(Tokens.TYPOGRAPHY.BODY.fontSize))
  * SINGLE_REM;

const calculateHeight = (height) => { // 1.5rem is multiplied for every addtional line
  if (height > SINGLE_LINE_HEIGHT) {
    const numberOfLines = Math.round(height / SINGLE_LINE_HEIGHT) - 1;
    return MIN_HEIGHT + (numberOfLines * 1.5);
  }
  return MIN_HEIGHT;
};

const cicleColors = $theme => keyframes`
  0% {
    stroke: ${$theme.progressInitialColor};
  }

  50% {
    stroke: rgb(${progressBarBackgroundColor(50, $theme)});
  }

  100% {
    stroke: ${$theme.progressFinalColor};
  }
`;

export default {
  Snackbar: styled.div`
    position: fixed;
    bottom: 0;
    direction: ${props => (props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.$theme.background};
    padding: 0 ${Tokens.SPACING.SPACING_24};
    border-radius: ${Tokens.RADIUS.RADIUS_2} ${Tokens.RADIUS.RADIUS_2} ${Tokens.RADIUS.RADIUS_0} ${Tokens.RADIUS.RADIUS_0};
    height: ${props => calculateHeight(props.$contentHeight)}rem;
    min-width: 18.75rem;
    max-width: 37.5rem;
    left: 50%;
    overflow: hidden;
    z-index: ${zIndex.TOOLTIP}
  `,
  SnackbarContent: styled.div`
    direction: ${props => (props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};
    color: ${props => props.$theme.content};
    width: 100%;
  `,
  SnackbarAction: styled.div`
    a[class^='styles__Anchor-'] {
      color: ${props => props.$theme.hyperlink};
    }
    ${circularProgressIndicatorIndeterminateStyles.CircleContainer} {
      ${({ $theme, $rtl }) => !$rtl && css`
        animation-name: ${circleAnimation}, ${cicleColors($theme)};
      `}
      ${({ $theme, $rtl }) => $rtl && css`
        animation-name: ${circleAnimationRtl}, ${cicleColors($theme)};
      `}
    }
    ${props => props.$rtl ? css`padding-right: ${Tokens.SPACING.SPACING_24};` : css`padding-left: ${Tokens.SPACING.SPACING_24};`};
`,
};
